/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowDCornerUpLeftIcon16Light } from './ArrowDCornerUpLeftIcon16Light';
import { ArrowDCornerUpLeftIcon16Regular } from './ArrowDCornerUpLeftIcon16Regular';
import { ArrowDCornerUpLeftIcon16Solid } from './ArrowDCornerUpLeftIcon16Solid';
import { ArrowDCornerUpLeftIcon20Light } from './ArrowDCornerUpLeftIcon20Light';
import { ArrowDCornerUpLeftIcon20Regular } from './ArrowDCornerUpLeftIcon20Regular';
import { ArrowDCornerUpLeftIcon20Solid } from './ArrowDCornerUpLeftIcon20Solid';
import { ArrowDCornerUpLeftIcon24Regular } from './ArrowDCornerUpLeftIcon24Regular';
import { ArrowDCornerUpLeftIcon24Solid } from './ArrowDCornerUpLeftIcon24Solid';
import { ArrowDCornerUpLeftIcon32Regular } from './ArrowDCornerUpLeftIcon32Regular';
import { ArrowDCornerUpLeftIcon64Regular } from './ArrowDCornerUpLeftIcon64Regular';
var sizes = {
    16: {
        light: ArrowDCornerUpLeftIcon16Light,
        regular: ArrowDCornerUpLeftIcon16Regular,
        solid: ArrowDCornerUpLeftIcon16Solid,
    },
    20: {
        light: ArrowDCornerUpLeftIcon20Light,
        regular: ArrowDCornerUpLeftIcon20Regular,
        solid: ArrowDCornerUpLeftIcon20Solid,
    },
    24: {
        regular: ArrowDCornerUpLeftIcon24Regular,
        solid: ArrowDCornerUpLeftIcon24Solid,
    },
    32: {
        regular: ArrowDCornerUpLeftIcon32Regular,
    },
    64: {
        regular: ArrowDCornerUpLeftIcon64Regular,
    },
};
export var ArrowDCornerUpLeftIcon = forwardRef('ArrowDCornerUpLeftIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
